'use strict';

const MODE = {
    0: "CLASS_A",
    1: "CLASS_B",
    2: "CLASS_C",
};

const OTA = {
    0: "OTA",
    1: "ABP",
};

const SWITCH = {
    0: "OFF",
    1: "ON",
};

const PERCENT = {
    1: "100%",
    10: "10%",
    100: "1%",
    1000: "0.1%",
};

const RATE = {
    0x00: 'SF12',
    0x01: 'SF11',
    0x02: 'SF10',
    0x03: 'SF9',
    0x04: 'SF8',
    0x05: 'SF7'
};

const REGION = {
    0x00: 'CN470',
    0x01: 'EU433',
    0x02: 'AS923',
    0x03: 'AU915',
    0x04: 'EU868',
    0x05: 'KR920',
    0x06: 'IN865',
    0x07: 'US915'
};

function parse(reader) {
    reader.readUInt8('data.params.mode', value => MODE[value]);
    reader.readUInt8('data.params.ota', value => OTA[value]);
    reader.readUInt8('data.params.adr', value => SWITCH[value]);
    reader.readUInt32LE('data.params.net_id');
    reader.readUInt32LE('data.params.dev_addr');
    reader.readUInt8('data.params.dev_eui');

    reader.readBuffer(8, 'data.params.app_eui', value => value.toString('hex'));
    reader.readBuffer(16, 'data.params.nwk_session_key', value => value.toString('hex'));
    reader.readBuffer(16, 'data.params.app_session_key', value => value.toString('hex'));
    reader.readBuffer(16, 'data.params.app_key', value => value.toString('hex'));

    reader.readUInt32LE('data.params.rx_win_delay_1');
    reader.readUInt32LE('data.params.rx_win_delay_2');
    reader.readUInt32LE('data.params.join_delay_1');
    reader.readUInt32LE('data.params.join_delay_2');
    reader.readUInt8('data.params.tx_power');
    reader.readUInt8('data.params.app_port');
    reader.readUInt8('data.params.confirm', value => value === 1);
    reader.readUInt16LE('data.params.chan_mask');

    for (let i = 1; i <= 16; i++) {
        reader.readUInt8(`data.params.freq_config.[${i}].freq_1`);
        reader.readUInt8(`data.params.freq_config.[${i}].freq_2`);
        reader.readUInt8(`data.params.freq_config.[${i}].freq_3`);
        reader.readUInt8(`data.params.freq_config.[${i}].freq_4`);
        reader.readUInt8(`data.params.freq_config.[${i}].dr`);
    }

    reader.readUInt8('data.params.def_dr', value => RATE[value]);
    reader.readUInt32LE('data.params.win_2_feq');
    reader.readUInt8('data.params.win_2_dr', value => RATE[value]);
    reader.readUInt32LE('data.params.duty_cycle_value', value => PERCENT[value]);
    reader.readUInt8('data.params.duty_cycle_switch', value => SWITCH[value]);
    reader.readUInt8('data.params.join_retries');
    reader.readUInt8('data.params.retries_tx');
    reader.readUInt32LE('data.params.ack_timeout');
    reader.readUInt8('data.params.link_check', value => SWITCH[value]);
    reader.readUInt8('data.params.sync_word');
    reader.readUInt8('data.params.region', REGION[value]);
    reader.readUInt32LE('data.params.up_link_counter');
    reader.readUInt32LE('data.params.down_link_counter');
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_1/common/rule/lorawan-config-parser.js